import React from 'react';
import { ListElemText, RoundStatus, useTranslation, DotsLoader } from '@pascal/pascal-core';
import { ResultCardsEnum } from '../../../../../enums';

export const statusMapper = (result, roundId) => {
  const { Started, Finished, Upcoming } = RoundStatus;
  if (result.status === Upcoming) {
    return Upcoming;
  }
  if (result.roundId === roundId && result.status === Started) {
    return Started;
  }
  return Finished;
};

const ListElementCart = ({ cardType }) => {
  return <div className={`l-c-sm-cards-wrp ${ResultCardsEnum[cardType]}`} />;
};

export const StatusRenderer = ({ result, status }) => {
  const t = useTranslation();

  const { Upcoming, Started } = RoundStatus;

  if (status === Upcoming) {
    return (
      <ListElemText className='inner-lists-item-row-item-txt t-t-n' noTextTransform>
        {t('SOON')}
      </ListElemText>
    );
  }
  if (status === Started) {
    return (
      <ListElemText forSaving>
        <DotsLoader />
      </ListElemText>
    );
  }

  return <ListElementCart cardType={result.roundData?.resultCard} />;
};
